(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ah-commerce-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ah-model-finder')) {
    customElements.define('ah-model-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.status = this.querySelector('[data-status]');
        this.results = this.querySelector('[data-results-list]');
        this.chart = this.querySelector('[data-chart]');
        this.form.addEventListener('submit', event => { event.preventDefault(); this.search(); }, { signal: this.controller.signal });
        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.searchController?.abort();
          this.chartController?.abort();
          this.results.replaceChildren();
          this.chart.replaceChildren();
          this.chart.hidden = true;
          this.status.textContent = '';
          if (this.input.value.trim().length >= 2) this.timer = setTimeout(() => this.search(), 300);
        }, { signal: this.controller.signal });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-product-url]');
          if (button && this.contains(button)) this.loadChart(button.dataset.productUrl, button.dataset.productTitle);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.searchController?.abort();
        this.chartController?.abort();
        this.controller = null;
      }
      async search() {
        clearTimeout(this.timer);
        const query = this.input.value.trim();
        if (query.length < 2) return;
        this.searchController?.abort();
        const controller = new AbortController();
        this.searchController = controller;
        this.status.textContent = this.dataset.loading;
        this.results.replaceChildren();
        try {
          const url = new URL(this.dataset.searchUrl, location.origin);
          url.searchParams.set('q', /dirndl/i.test(query) ? query : 'Dirndl ' + query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '10');
          url.searchParams.set('resources[options][unavailable_products]', 'show');
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          const data = await response.json();
          if (controller.signal.aborted) return;
          const terms = query.toLocaleLowerCase('de').split(/\s+/).filter(term => term !== 'dirndl');
          const products = (data.resources?.results?.products || []).filter(product => /\bdirndl\b/i.test(product.title) && terms.every(term => product.title.toLocaleLowerCase('de').includes(term))); 
          for (const product of products) {
            const item = document.createElement('li');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ah-guide__model-choice';
            button.dataset.productUrl = product.url;
            button.dataset.productTitle = product.title;
            const imageUrl = product.featured_image?.url || product.image;
            if (imageUrl) {
              const thumbnail = document.createElement('img');
              const thumbnailUrl = new URL(imageUrl, location.origin);
              thumbnailUrl.searchParams.set('width', '120');
              thumbnail.src = thumbnailUrl.href;
              thumbnail.alt = '';
              thumbnail.width = 60;
              thumbnail.height = 75;
              thumbnail.loading = 'lazy';
              button.append(thumbnail);
            }
            const name = document.createElement('span');
            name.textContent = product.title;
            button.append(name);
            item.append(button);
            this.results.append(item);
          }
          this.status.textContent = products.length ? this.dataset.results + ': ' + products.length : this.dataset.empty;
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
        }
      }
      async loadChart(productUrl, title) {
        this.chartController?.abort();
        const controller = new AbortController();
        this.chartController = controller;
        this.chart.hidden = false;
        this.chart.replaceChildren();
        this.chart.setAttribute('aria-busy', 'true');
        const heading = document.createElement('h3');
        heading.textContent = title;
        this.chart.append(heading);
        const message = document.createElement('p');
        message.textContent = this.dataset.chartLoading;
        this.chart.append(message);
        const supplied = new URL(productUrl, location.origin);
        const url = new URL(supplied.pathname, location.origin);
        url.searchParams.set('preview_theme_id', this.dataset.themeId);
        const source = document.createElement('a');
        source.href = url.href;
        source.textContent = this.dataset.sourceLabel;
        try {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('chart');
          const html = await response.text();
          if (controller.signal.aborted) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nativeChart = doc.querySelector('[data-ah-size-chart] .accordion__content');
          const image = nativeChart?.querySelector('.size_chart_img img');
          if (!image) throw new Error('chart unavailable');
          const img = document.createElement('img');
          img.src = image.getAttribute('src');
          if (image.getAttribute('srcset')) img.srcset = image.getAttribute('srcset');
          img.sizes = '(min-width: 750px) 800px, 100vw';
          img.alt = 'Größentabelle – ' + title;
          if (image.width) img.width = image.width;
          if (image.height) img.height = image.height;
          const fullImage = document.createElement('a');
          fullImage.href = img.src;
          fullImage.target = '_blank';
          fullImage.rel = 'noopener';
          fullImage.setAttribute('aria-label', img.alt + ' vergrößern');
          fullImage.append(img);
          message.remove();
          this.chart.append(fullImage);
        } catch (error) {
          if (error.name === 'AbortError') return;
          message.textContent = this.dataset.chartError;
        }
        if (!controller.signal.aborted) {
          this.chart.append(source);
          this.chart.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
